export const CONSENT_CATEGORY_MARKETING = "C0001MT";
export const CONSENT_CATEGORY_ANALYTICS = "C0002AL";

export type ConsentCategory =
  | typeof CONSENT_CATEGORY_MARKETING
  | typeof CONSENT_CATEGORY_ANALYTICS;

export type ConsentPreferences = {
  readonly [K in ConsentCategory]: boolean;
};

export type StoredConsent = {
  readonly version: 1;
  readonly preferences: ConsentPreferences;
  readonly updatedAt: string;
};

export type ConsentCategoryInfo = {
  readonly id: ConsentCategory;
  readonly label: string;
  readonly description: string;
  readonly alwaysOn: boolean;
  readonly defaultValue: boolean;
};
